import React, { useState } from "react";
import {
  Tooltip,
  IconButton,
  Button,
  Popper,
  Paper,
  Stack,
  Typography,
  Box,
} from "@mui/material";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import {
  OpenInNewWindowIcon,
  CallMadeIcon,
} from "../../../../components/mui/index.js";

export function OpenInActions({ data }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <Tooltip title={!open ? <Typography>Links</Typography> : null}>
        <IconButton onClick={handleClick}>
          <OpenInNewWindowIcon />
        </IconButton>
      </Tooltip>
      <Popper
        open={open}
        anchorEl={anchorEl}
        placement="bottom-start"
        style={{ zIndex: 1300 }}
      >
        <ClickAwayListener onClickAway={handleClose}>
          <Paper sx={{ p: 2, minWidth: 220 }}>
            <Stack spacing={1} d>
              {data?.invoices?.map((invoice) => (
                <Box key={invoice.Id}>
                  <Button
                    variant="outlined"
                    size="small"
                    startIcon={<OpenInNewWindowIcon />}
                    onClick={(e) => {
                      e.stopPropagation();
                      window.open(
                        `https://qbo.intuit.com/app/invoice?txnId=${invoice?.Id}`,
                        "_blank"
                      );
                      handleClose();
                    }}
                    fullWidth
                  >
                    {data?.invoices?.length > 1 ? (
                      <Typography>
                        {" "}
                        Invoice Num: {invoice.DocNumber} Open in QuickBooks{" "}
                      </Typography>
                    ) : (
                      <Typography> Open in QuickBooks </Typography>
                    )}
                  </Button>
                </Box>
              ))}

              {data?.contract_third_party_info?.stripe_customer_id && (
                <Button
                  variant="outlined"
                  size="small"
                  startIcon={<OpenInNewWindowIcon />}
                  onClick={(e) => {
                    e.stopPropagation();
                    window.open(
                      `https://dashboard.stripe.com/customers/${data?.contract_third_party_info.stripe_customer_id}`,
                      "_blank"
                    );
                    handleClose();
                  }}
                  fullWidth
                >
                  Open in Stripe
                </Button>
              )}
              {data?.contract_third_party_info?.pandadoc_id && (
                <Button
                  variant="outlined"
                  size="small"
                  startIcon={<OpenInNewWindowIcon />}
                  onClick={(e) => {
                    e.stopPropagation();
                    window.open(
                      `https://app.pandadoc.com/a/#/documents/${data?.contract_third_party_info.pandadoc_id}`,
                      "_blank"
                    );
                    handleClose();
                  }}
                  fullWidth
                >
                  Open in PandaDoc
                </Button>
              )}
              {data?.contract_third_party_info?.hubspot_deal_id && (
                <Button
                  variant="outlined"
                  size="small"
                  startIcon={<OpenInNewWindowIcon />}
                  onClick={(e) => {
                    e.stopPropagation();
                    window.open(
                      `https://app.hubspot.com/contacts/21771408/record/0-3/${data?.contract_third_party_info.hubspot_deal_id}`,
                      "_blank"
                    );

                    handleClose();
                  }}
                  fullWidth
                >
                  Open in HubSpot
                </Button>
              )}

              {!data?.invoices?.length && !data.contract_third_party_info && (
                <Typography variant="body2" color="textSecondary">
                  No external links available.
                </Typography>
              )}
            </Stack>
          </Paper>
        </ClickAwayListener>
      </Popper>
    </>
  );
}
